import { atomWithStorage } from "jotai/utils";

export const challengesNewAtom = atomWithStorage("WOG_challenges_new", []);
export const challengesMineAtom = atomWithStorage("WOG_challenges_mine", []);
export const discoverChallengesAtom = atomWithStorage(
  "WOG_challenges_data",
  []
);
